angular
  .module('survey')
  .factory('validator', ['queryParser', '$httpParamSerializer', validator]);

function validator(queryParser, $httpParamSerializer) {
  return {
    validatePage,
    determineRedirect,
  };

  function validatePage(state) {
    var errors = {};
    if (
      state.layout === 'classic-intro'
        ? state.page === 2
        : state.page === 1
    ) {
      if (state.require_email_field && !state.email) {
        // validate email
        errors.email = 'Please enter a valid email address.';
      } else if (state.require_cell_phone && !state.cell_phone) {
        // validate cell_phone
        errors.cell_phone = 'Please enter a valid phone number.';
      }
    }
    for (var i = 0; i < state.questions.length; i++) {
      var q = state.questions[i];
      const type = q.type.toLowerCase().split(' ').join('_');
      if (
        q.page === state.page &&
        q.required &&
        q.has_pii_response &&
        !state[type]
      ) {
        errors[q.id] = 'This question is required.';
      } else if (
        q.page === state.page &&
        q.required &&
        !q.has_pii_response &&
        !state.responses[state.page - 1][q.id]
      ) {
        errors[q.id] = 'This question is required.';
      }
    }
    return errors;
  }

  function determineRedirect(state) {
    // check if we should redirect the user (who just submitted a page) to somewhere else.
    var redirect = {};
    for (var i = 0; i < state.questions.length; i++) {
      var question = state.questions[i];
      if (question.page === state.page || state.onepage) {
        var response = state.responses[question.page - 1][question.id];
        if (question.type === 'Radio' || question.type === 'Dropdown') {
          if (response) {
            // check the redirect behavior of this response
            var option = question.options.find(
              (opt) => opt.id === parseInt(response.option_id)
            );
            if (option.redirect_behavior_type) {
              redirect.type = option.redirect_behavior_type;
              redirect.page = option.redirect_page_number;
              redirect.url = option.redirect_url;
              // check if there is sustainers redirect
              if (redirect.type === 'url') {
                if (state.sustainers && option.sustainer_redirect_url) {
                  redirect.url = option.sustainer_redirect_url;
                } else if (
                  (!option.sustainer_redirect_url && option.redirect_url) ||
                  !state.sustainers
                ) {
                  if (option.redirect_url) {
                    redirect.url = option.redirect_url;
                  } else {
                    // make non-sustainers redirect type null if there is no redirect url
                    redirect.type = null;
                  }
                }
              }
              break;
            }
          } else if (question.default_redirect_behavior_type) {
            // the user did not answer this question, so apply the default redirect behavior for this question if there is any
            if (question.default_redirect_behavior_type) {
              // change auto_progress back to the default null value to preserve "Continue" behavior defaults
              if (question.default_redirect_behavior_type === 'auto_progress') {
                redirect.type = null;
              } else {
                redirect.type = question.default_redirect_behavior_type;
              }
              redirect.page = question.default_redirect_page_number;
              // check if there is sustainers redirect
              if (redirect.type === 'url') {
                if (
                  state.sustainers &&
                  question.default_sustainer_redirect_url
                ) {
                  redirect.url = question.default_sustainer_redirect_url;
                } else if (
                  (!question.default_sustainer_redirect_url &&
                    question.default_redirect_url) ||
                  !state.sustainers
                ) {
                  if (question.default_redirect_url) {
                    redirect.url = question.default_redirect_url;
                  } else {
                    // make non-sustainers redirect type null if there is no redirect url
                    redirect.type = null;
                  }
                }
              }
              break;
            }
          }
        } else if (question.type === 'Express Lane') {
          if (response) {
            redirect.type = 'url';
            if (response.numeric_value) {
              redirect.url = `https://secure.actblue.com/contribute/page/${question.actblue_slug}?express_lane=true&amount=${response.numeric_value}`;
            } else {
              redirect.url = `https://secure.actblue.com/contribute/page/${question.actblue_slug}`;
            }
            // Other query string params will be added below
            break;
          }
        }
      }
    }

    // if we didn't pick a redirect above, but this is the end of the survey, we apply the default redirect
    if ((state.last_page || state.onepage) && !redirect.type) {
      if (state.default_redirect) {
        redirect.type = 'url';
        redirect.url = state.default_redirect;
      } else {
        redirect.type = 'thanks';
      }
    }

    // apply refcode, amounts, stuff like that to URLs
    if (redirect.type === 'url' && redirect.url) {
      redirect.url = adjustRedirectQueryString(state, redirect.url);
    }
    return redirect;
  }

  function adjustRedirectQueryString(state, url) {
    const host = new URL(url).host;
    var redirectIsActBlue = host === ('secure.actblue.com');
    var redirectIsSalsaDonatePage = url.indexOf('donate_page_KEY') !== -1;
    var redirectIsLuminate = host === ('convio.net') || url.indexOf('Donation2') !== -1;
    if (redirectIsActBlue || redirectIsSalsaDonatePage || redirectIsLuminate) {
      // attach special query string variables for actblue/salsa

      var currentParams = queryParser(state.query);
      // find query params for the place we are redirecting to so we can check for and modify them as needed
      if (url.indexOf('?') !== -1) {
        // get current query from redirect, then remove it so we can rebuild it
        var redirectParams = queryParser(url.slice(url.indexOf('?')));
        url = url.slice(0, url.indexOf('?'));
      } else {
        var redirectParams = {};
      }

      if (redirectIsActBlue) {
        var includeParams = {
          // name in our query string: name in AB's query string
          code: 'refcode',
          amount: 'amount',
          amounts: 'amounts',
          refcode2: 'refcode2',
          sustainers: 'recurring',
        };
      } else if (redirectIsSalsaDonatePage) {
        var includeParams = {
          // name in our query string: name in Salsa's query string
          code: 'track',
          amount: 'amount',
          amounts: 'amounts',
          sustainers: 'recurring',
        };
      } else if (redirectIsLuminate) {
        // name in our query string: name in Luminate's query string
        var includeParams = {
          code: 's_src',
        };
      }

      for (var param in includeParams) {
        var nameInRedirect = includeParams[param];
        var currentValueInRedirect = redirectParams[nameInRedirect] || '';
        // If this param does not exist in the redirect now, add it based on our query string
        if (currentParams[param] && !currentValueInRedirect) {
          redirectParams[nameInRedirect] = currentParams[param];
          // Update this variable to use below
          currentValueInRedirect = currentParams[param];
        }

        // If we should be appending to the refcode or refcode2, do that now
        if (param === 'code' && state.append_refcode) {
          if (currentValueInRedirect) {
            redirectParams[nameInRedirect] += '-' + state.append_refcode;
          } else {
            redirectParams[nameInRedirect] = state.append_refcode;
          }
        } else if (param === 'refcode2' && state.append_refcode2) {
          if (currentValueInRedirect) {
            redirectParams[nameInRedirect] += '-' + state.append_refcode2;
          } else {
            redirectParams[nameInRedirect] = state.append_refcode2;
          }
        }
      }

      url += '?' + $httpParamSerializer(redirectParams);
    }

    return url;
  }
}
